import React from 'react'
import { useTranslation } from 'react-i18next'
import { tr } from 'i18n'
import './DriverFilters.scss'

const filters = [
  { value: '', label: 'Все' },
  { value: 'free', label: 'Свободен' },
  { value: 'loading', label: 'В погрузке' },
  { value: 'blocked', label: 'Заблокирован' },
  { value: 'inactive', label: 'Не активен' },
  { value: 'invalid_number', label: 'Есть ошибка в номере' },
  { value: 'no_driver', label: 'Транспорт без водителей' },
]

const transportStatuses = [
  { value: '', label: 'Все статусы' },
  { value: 'not_blocked', label: 'Без заблокированных' },
  { value: 'free', label: 'Свободен' },
  { value: 'loading', label: 'В погрузке' },
  { value: 'blocked', label: 'Заблокирован' },
]

type Props = { value: string; onChange: (value: string) => void; transportStatus: string; onTransportStatusChange: (value: string) => void }

export default function DriverFilters({ value, onChange, transportStatus, onTransportStatusChange }: Props) {
  useTranslation()
  return <><div className="driver-filters" role="group" aria-label={tr('Фильтры водителей')}>
    {filters.map(filter => <button key={filter.value} type="button" aria-pressed={value === filter.value}
      className={`driver-filters__button${value === filter.value ? ' driver-filters__button--active' : ''}`}
      onClick={() => onChange(filter.value)}>{tr(filter.label)}</button>)}
  </div>
    {value === 'invalid_number' && <label className="driver-filters__status">{tr('Статус транспорта')}
      <select value={transportStatus} onChange={event => onTransportStatusChange(event.target.value)}>
        {transportStatuses.map(status => <option key={status.value} value={status.value}>{tr(status.label)}</option>)}
      </select>
    </label>}
  </>
}
